import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/api.service';
import { CloneDialogComponent } from '../clone-dialog/clone-dialog.component';
import { ConformationComponent } from '../conformation/conformation.component';
import { CreateUpdateGroupComponent } from '../create-update-group/create-update-group.component';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GroupsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] ;
  dataSource :any;
  showSpinner = false;
  screenwidth =null;
  dialogwidth = null;
  allGroups = [];
  filteredGroups = [];
  searchText;
  userInfo = JSON.parse(localStorage.getItem('User'));
  userRole = this.userInfo.roles[0];
  constructor(private dialog: MatDialog,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar) {
    
  }

  ngOnInit(): void {
    this.screenwidth = screen.width;
    if(this.screenwidth < 500){
      this.dialogwidth = '90%';
    }else{
      this.dialogwidth = '50%';
    }

    if(this.userRole =='admin'){
      // this.displayedColumns = ['name','id', 'description', 'company_id', 'created_at', 'updated_at'];
      this.displayedColumns = ['name', 'description', 'id', 'created_at', 'updated_at', 'company_id','selected'];
    }else if(this.userRole =='manager'){
      this.displayedColumns = ['name','id', 'description', 'created_at'];
    }

    this.refreshGrouplist();
  }

  refreshGrouplist(){
    this.showSpinner = true;
    this._apiService.getGroupList().subscribe(res => {
      if (res) {
        this.allGroups = res;
        this.filteredGroups = res;
        let groupWithSelectedValue = [];
        for(var i=0; i<this.allGroups.length; i++){
          let instance = this.allGroups[i];
          instance['selected'] = false;
          groupWithSelectedValue.push(instance);
        }
        this.dataSource = new MatTableDataSource<groupList>(groupWithSelectedValue);
        setTimeout(() => this.dataSource.paginator = this.paginator);
        setTimeout(() => this.dataSource.sort = this.sort);
        this.showSpinner = false;
      }
    },
    (error)=>{
      this.showSpinner = false;
    });
  }

  openDialog(type,groupInfo): void {
    const dialogRef = this.dialog.open(CreateUpdateGroupComponent, {
      width: this.dialogwidth,
      data: {groupList: this.allGroups, type:type, groupInfo:groupInfo}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.refreshGrouplist();
    });
  }

  deleteGroup(data){
    const dialogRef = this.dialog.open(ConformationComponent, {
      width: '20rem',
      data: {id: data.id,type:'Group'}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.refreshGrouplist();
    });
    
  }

  cloneGroup(data){
    console.log(data.id);
    const dialogRef = this.dialog.open(CloneDialogComponent, {
      width: '20rem',
      data: {id: data.id,type:'group'}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.refreshGrouplist();
    });
  }

  onSearch(e){
    if(e == null){
      this.filteredGroups = this.allGroups;
      this.dataSource = new MatTableDataSource<groupList>(this.allGroups);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    this.filteredGroups = this.allGroups.filter(ele => ele.name.toLowerCase().includes(e.toLowerCase()));
    this.dataSource = new MatTableDataSource<groupList>(this.filteredGroups);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}

export interface groupList {
  id: number;
  name: string;
  description: string;
  company_id: number;
  created_at:string;
  updated_at:string;
  selected: boolean;
};
